import '@/types';
import repository from '@/modules/machinery/services/machineryProfilesRepository';
import notificationService from '@/services/notificationService';

export default class MachineryProfile implements IMachineryProfile {
    public id: string = '';

    public name: string = '';
    public fields: IMachineryCustomFieldDefinition[] = [];

    public saving: boolean = false;
    public loading: boolean = false;
    public dirty: boolean = false;

    public async init(id: string) {
        try {
            this.loading = true;
            const result = await repository.getSingle(id);

            Object.assign(this, result.data);
        } catch (err) {
            notificationService.failedToLoad();
        } finally {
            this.loading = false;
        }
    }

    public async save() {
        try {
            this.saving = true;
            const result = await repository.update(this);
            notificationService.saved();
            this.dirty = false;
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.saving = false;
        }
    }

    public async delete() {
        try {
            this.saving = true;
            await repository.delete(this.id);
            return true;
        } catch (err) {
            notificationService.showAxiosError(err);
            this.saving = false;
            return false;
        }
    }
}
